import type { MessageRender } from "@product/scmp-sdk/dist/types/components/dashboard-widget/display/hooks";
import { useCallback, useMemo } from "react";
import { isIOS } from "react-device-detect";

import { useScmpWidgetConfig } from "scmp-app/lib/app/hooks";

import { AppPromotionMessage } from ".";

export const useAppPromotionMessageRender = () => {
  const { scmpWidgetConfigState } = useScmpWidgetConfig();

  const emptyMessageRender = useMemo<MessageRender>(() => () => Promise.resolve(null), []);
  const asyncMessageRender = useCallback<MessageRender>(() => {
    if (
      scmpWidgetConfigState.status === "loading" ||
      scmpWidgetConfigState.status === "not-executed"
    ) {
      return new Promise(() => {});
    }

    if (
      scmpWidgetConfigState.status === "error" ||
      scmpWidgetConfigState.result?.notification_widget_download_cta !== "1"
    ) {
      return Promise.resolve(null);
    }
    return Promise.resolve(<AppPromotionMessage />);
  }, [scmpWidgetConfigState]);

  const appPromotionMessageRender = useMemo<MessageRender>(() => {
    if (!isIOS) return emptyMessageRender;
    return asyncMessageRender;
  }, [asyncMessageRender, emptyMessageRender]);

  return { appPromotionMessageRender };
};
